import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquitool-tip',
	templateUrl:'./JQUIToolTipPluginCompPage.html',
	styles: [],
	styleUrls:['./JQUIToolTipPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIToolTipPluginCompPage
{
	mdContent_1030 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.tooltips.JQUIToolTip;
\`\`\``;
	mdContent_1031 = `\`\`\`java
JQUIToolTip()
\`\`\``;
	mdContent_1032 = `\`\`\`java
JQUIToolTip&lt;?&gt; tooltip = new JQUIToolTip&lt;&gt;();
tooltip.getOptions().setContent("Helpful information");
tooltip.getOptions().setTrack(true);
tooltip.getOptions().setShow("slideDown");
\`\`\``;
}
